import { DateTime, Duration } from 'luxon'
import { useSystemStore } from './stores/system'
import { filesize } from 'filesize'
import Str from 'laravel-js-str'

export default {
  install: (app) => {
    app.config.globalProperties.$filters = {
      date(timestamp, fallback = '##INVALID_TIMESTAMP##', weekday = false, zone = null) {
        return timestamp
          ? DateTime.fromISO(timestamp, { zone }).toLocaleString(weekday ? DateTime.DATE_HUGE : DateTime.DATE_FULL)
          : fallback
      },
      time(timestamp, fallback = '##INVALID_TIMESTAMP##', zone = null) {
        if (!timestamp) {
          return fallback
        }

        const time = DateTime.fromISO(timestamp, { zone })
        return time.toLocaleString(DateTime.TIME_SIMPLE) + (zone ? ` ${time.toFormat('ZZZZ')}` : '')
      },
      duration(seconds) {
        if (seconds < 60) {
          return seconds === 1 ? '1 second' : `${seconds} seconds`
        }

        return Duration.fromObject({ seconds })
          .shiftTo('hours', 'minutes')
          .normalize()
          .toHuman({ maximumFractionDigits: 0, unitDisplay: 'long' })
          .replace(/^0 hours, |, 0 minutes$/g, '')
      },
      datetime(timestamp, fallback = '##INVALID_TIMESTAMP##', weekday = false, zone = null) {
        if (!timestamp) {
          return fallback
        }

        const time = DateTime.fromISO(timestamp, { zone })
        return (
          time.toLocaleString(weekday ? DateTime.DATETIME_MED_WITH_WEEKDAY : DateTime.DATETIME_MED) +
          (zone ? ` ${time.toFormat('ZZZZ')}` : '')
        )
      },
      week(timestamp, fallback = '##INVALID_TIMESTAMP##') {
        return timestamp ? DateTime.fromISO(timestamp).toFormat("'Week' W, kkkk") : fallback
      },
      trans(key, value) {
        const store = useSystemStore()
        let dictionary = store.enums
        let pieces = key.split('.')
        for (let i = 0; i < pieces.length; i++) {
          if (!dictionary[pieces[i]]) {
            console.log('invalid key', pieces[i], dictionary)
            return '###INVALID###'
          }

          dictionary = dictionary[pieces[i]]
        }
        if (typeof value === 'undefined') {
          return dictionary || []
        }

        const match = dictionary.find((i) => i.id.toString() === value?.toString())
        if (typeof match !== 'undefined') {
          return match.name
        }

        return '###INVALID###'
      },
      number(number, decimals = false) {
        if (isNaN(number) || number === null) {
          return number
        }

        return Number(number)
          .toFixed(decimals ? 2 : 0)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      currency(value, currency = 'GBP', decimals = null) {
        if (decimals === null && !isNaN(value) && value % 1 > 0) {
          decimals = true
        }
        return `${value < 0 ? '-' : ''}${this.trans('property.currencySymbol', currency)}${this.number(Math.abs(value), decimals)}`
      },
      filesize(bytes) {
        return filesize(bytes)
      },
      basename(path) {
        return path.split('/').pop()
      },
      sensor(value) {
        return value.replace(/./gi, '*')
      },
      sensorEmail(email, uncensoredCharacters = 4) {
        if (!email) {
          return null
        }

        const emailArray = email.split('@')
        if (emailArray.length < 2) {
          return this.sensor(email)
        }
        return emailArray[0].substring(0, uncensoredCharacters) + '*****@' + emailArray[1]
      },
      titleCase(string) {
        return Str.snake(string)
          .toLowerCase()
          .replaceAll('_', ' ')
          .replace(/\b\w/g, (s) => s.toUpperCase())
      }
    }
  }
}
